import React, { useMemo } from 'react'
import { Table, Button, Space, Tag } from 'antd'
import { EditOutlined, EyeOutlined, SettingOutlined, PushpinFilled } from '@ant-design/icons'
import dayjs from 'dayjs'
import { ENDPOINTS } from '../../Services/ENDPOINTS'

const PINNED_IDS = ["8", "9", "12", "13", "14"]


const ListAllPage = ({ data = [], onEdit, onManage }) => {

  // Move pinned pages to top
  const sortedData = useMemo(() => {
    const pinned = data.filter(item => PINNED_IDS.includes(item.id))
    const normal = data.filter(item => !PINNED_IDS.includes(item.id))
    return [...pinned, ...normal]
  }, [data])

  const columns = [
    {
      title: 'SI. No.',
      key: 'serial',
      align: 'center',
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <Space>
          {PINNED_IDS.includes(record.id) && (
            <PushpinFilled style={{ color: '#faad14' }} />
          )}
          {text}
        </Space>
      ),
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
      ellipsis: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status?.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => dayjs(date).format('DD MMM YYYY, HH:mm'),
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            size="small"
            ghost
            icon={<EyeOutlined />}
            onClick={() =>
              window.open(`${ENDPOINTS.HOST}${record.slug}`, '_blank', 'noopener,noreferrer')
            }
          >
            Preview
          </Button>

          <Button
            type="primary"
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
          >
            Edit
          </Button>

          <Button
            size="small"
            icon={<SettingOutlined />}
            onClick={() => onManage?.(record)}
          >
            Manage
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={sortedData}
      pagination={{ pageSize: 12 }}
    />
  )
}

export default ListAllPage
